module.exports = __webpack_public_path__ + "static/media/traista-logo.a59c0bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/traista-logo.png
// module id = 927
// module chunks = 0